import {
  GET_TEMPLATES,
  GET_TEMPLATES_ERROR,
  GET_TEMPLATES_SUCCESS,
  GetTemplatesAction,
  GetTemplatesErrorAction,
  GetTemplatesSuccessAction,
} from "./actionTypes";
import { SelectListDto } from "../../models";

//#region Get Templates

export const getTemplates = (): GetTemplatesAction => {
  return {
    type: GET_TEMPLATES,
    payload: null,
  };
};

export const getTemplatesSuccess = (
  response: SelectListDto[]
): GetTemplatesSuccessAction => {
  return {
    type: GET_TEMPLATES_SUCCESS,
    payload: response,
  };
};

export const getTemplatesError = (error: any): GetTemplatesErrorAction => {
  return {
    type: GET_TEMPLATES_ERROR,
    payload: error,
  };
};

//#endregion
